<template>
  <div>
    <v-dialog
      v-model="dialog"
      scrollable 
      persistent
      max-width="800px"
      transition="dialog-transition"
    >
      <v-card :outlined="$vuetify.theme.isDark">
        <v-card-title primary-title style="word-break: break-word">
          Comentário do item "{{ item.title }}"
        </v-card-title>
        <v-card-text class="py-2">
          <v-textarea
            label="Comentário de reprovação"
            v-model="comment"
            prepend-icon="mdi-comment-text"
            :disabled="readonly"
            :rules="required"
            outlined
            color="secondary"
          ></v-textarea>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-end">
          <v-btn
            color="error"
            text 
            @click="$emit('close')"
          >
            <v-icon>mdi-close</v-icon>
            Fechar
          </v-btn>
          <v-btn
            v-if="!readonly"
            color="success"
            text 
            @click="saveComment()"
          >
            <v-icon>mdi-content-save</v-icon>
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import validations from '@/mixins/validations';

  export default {
    name: "CommentDialog",
    props: {
      item: {
        type: Object,
        default: () => {}
      },
      readonly: {
        type: Boolean,
        default: false
      }
    },
    mixins: [
      validations
    ],
    data() {
      return {
        dialog: true,
        comment: null
      }
    },
    mounted () {
      this.setComment();
    },
    methods: {
      setComment() {
        if (this.item.reject_comment) {
          this.comment = this.item.reject_comment;
        } else if (this.item.reproval_motive) {
          this.comment = this.item.reproval_motive;
        }
      },
      saveComment() {
        this.$emit('updateItem', this.comment);
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>